module.exports = __webpack_public_path__ + "../resources/images/dialog_illustration_bckgrd-f8d57a0dcaba043db02b94690aba156e.svg";